<template>
  <div class="search-box" id="searchBox">
    <el-form
      :model="formModel"
      :ref="tempFromName"
      class="demo-formData"
      label-position="right"
      :inline="true"
      @submit.native.prevent
    >
      <!--功能按钮-->
      <div
        class="more-little"
        :class="{
          'inline-flex':
            searchOptions &&
            (!searchOptions.simple || searchOptions.simple.length == 0)
        }"
      >
        <template v-for="toolItem in toolConfig">
          <template v-if="toolItem.filter ? toolItem.filter(toolItem) : true">
            <el-button
              :key="toolItem.code"
              :type="
                toolItem.code.toLowerCase().indexOf('delete') != -1
                  ? 'danger'
                  : 'primary'
              "
              class="
                {'button-red':toolItem.code.toLowerCase().indexOf('delete')
                !=
                -1?}
              "
              @click="btnCommon(toolItem)"
              plain
            >
              {{ toolItem.name || toolItem.label }}
            </el-button>
          </template>
        </template>
      </div>
      <div
        class="form-item-wrapper"
        :class="{
          'inline-flex':
            searchOptions &&
            (!searchOptions.simple || searchOptions.simple.length == 0)
        }"
      >
        <template
          v-for="(column, index) in searchOptions && searchOptions.simple"
        >
          <!--单条搜索-->
          <template v-if="searchOptions && searchOptions.simple.length == 1">
            <el-form-item
              style="min-height: auto"
              :key="index"
              label=""
              :prop="column.prop"
              v-if="column.hidden == true ? false : true"
              :label-width="
                column.labelWidth || searchOptions.labelWidth || '100px'
              "
            >
              <!--输入框-->
              <el-input
                class="search-input"
                v-if="column.type === columnType.input || !column.type"
                v-model.trim="formModel[column.prop]"
                :placeholder="column.placeholder"
                @change="searchValue(column)"
                clearable
              >
                <el-button
                  type="primary"
                  slot="append"
                  @click="searchValue(column)"
                  >查询</el-button
                >
              </el-input>
              <!--下拉框-->
              <el-select
                :clearable="column.clearable ? false : true"
                v-else-if="column.type === columnType.select"
                v-model="formModel[column.prop]"
                placeholder="请选择"
                @change="searchValue(column)"
                :multiple="column.multiple || false"
                collapse-tags
                filterable
                :disabled="column.disabled"
              >
                <el-option
                  v-for="item in column.data"
                  :key="item[column.uniqueKey] || item.value || item.id"
                  :label="item[column.labelKey] || item.label || item.name"
                  :title="item[column.labelKey] || item.label || item.name"
                  :value="item[column.uniqueKey] || item.value || item.id"
                ></el-option>
              </el-select>
              <el-button
                v-if="column.type === columnType.select"
                type="primary"
                @click="searchValue(column)"
                >查询
              </el-button>
            </el-form-item>
          </template>
          <!--多条搜索-->
          <template v-if="searchOptions && searchOptions.simple.length > 1">
            <el-form-item
              :key="index"
              :label="column.label"
              :prop="column.prop"
              v-if="column.hidden == true ? false : true"
              :label-width="
                column.labelWidth || searchOptions.labelWidth || '100px'
              "
            >
              <!--输入框-->
              <el-input
                v-if="column.type === columnType.input || !column.type"
                v-model.trim="formModel[column.prop]"
                :placeholder="column.placeholder"
                @keyup.enter.native="valueChange(column)"
              ></el-input>
              <!--下拉框-->
              <el-select
                :clearable="column.clearable ? false : true"
                v-else-if="column.type === columnType.select"
                v-model="formModel[column.prop]"
                :placeholder="column.placeholder || '请选择'"
                @change="selectChange(column)"
                :multiple="column.multiple || false"
                collapse-tags
                filterable
                :disabled="column.disabled"
              >
                <el-option
                  v-for="item in column.data"
                  :key="item[column.uniqueKey] || item.value || item.id"
                  :label="item[column.labelKey] || item.label || item.name"
                  :title="item[column.labelKey] || item.label || item.name"
                  :value="item[column.uniqueKey] || item.value || item.id"
                ></el-option>
              </el-select>
              <!--单选按钮-->
              <el-radio-group
                v-else-if="column.type === columnType.radio"
                v-model="formModel[column.prop]"
                @change="radioChange(column)"
                :disabled="column.disabled"
              >
                <el-radio
                  v-for="item in column.data"
                  :key="item.label || item.name"
                  :label="item.label || item.name"
                  :value="item.label || item.name"
                ></el-radio>
              </el-radio-group>

              <!--多选按钮-->
              <el-checkbox-group
                v-else-if="column.type === columnType.checkbox"
                v-model="formModel[column.prop]"
              >
                <el-checkbox
                  v-for="item in column.data"
                  :key="item.value || item.id"
                  :label="item.label || item.name"
                  :title="item.label || item.name"
                  :value="item.value || item.id"
                ></el-checkbox>
              </el-checkbox-group>

              <!---级联下拉框----->
              <casader-select
                :ref="column.prop"
                v-else-if="column.type === columnType.casaderSelect"
                :formModel="formModel"
                @cascaderChange="cascaderChange"
                :column="column"
              ></casader-select>
              <!--单选选择任意一级选项-->
              <el-cascader
                v-if="column.type === columnType.cascader"
                v-model="formModel[column.prop]"
                :options="column.data"
                @change="valueChange(column)"
                :props="{
                  expandTrigger: 'click',
                  checkStrictly: true,
                  emitPath: column.emitPath || false,
                  label: column.labelKey || 'label',
                  value: column.valueKey || 'id',
                  children: column.childrenKey || 'children'
                }"
              ></el-cascader>
              <el-cascader
                :options="column.data"
                v-if="column.type === columnType.cascaderMultiple"
                v-model="formModel[column.prop]"
                :props="cascaderProp"
                :placeholder="column.placeholder || '请选择'"
                collapse-tags
                @change="valueChangeMultiple($event, column)"
              >
                <!--                <template slot-scope="{data }">-->
                <!--                  <div v-if="column.data[0].label == data.label">-->
                <!--                    <el-checkbox-->
                <!--                      v-model="isCheckedAll"-->
                <!--                      @change="checkAll($event, column)"-->
                <!--                      class="all-select-style"-->
                <!--                    >全选-->
                <!--                    </el-checkbox>-->
                <!--                    <span>{{ data.label }}</span>-->
                <!--                  </div>-->
                <!--                </template>-->
              </el-cascader>
              <!--日期选择器-->
              <el-date-picker
                v-else-if="column.type === columnType.datePicker"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                v-model="formModel[column.prop]"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
              <!--开关-->
              <el-switch
                v-else-if="column.type === columnType.switch"
                v-model="formModel[column.prop]"
                @change="valueChange(column)"
              ></el-switch>
              <!--日期时间选择器-->
              <el-date-picker
                v-else-if="column.type === columnType.dateTimePicker"
                type="datetime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="formModel[column.prop]"
                placeholder="选择日期时间"
              ></el-date-picker>
              <date-time-range
                :ref="column.prop"
                v-else-if="column.type === columnType.datetimeRange"
                :column="column"
              ></date-time-range>
              <date-time-range-button
                :ref="column.prop"
                v-else-if="column.type === columnType.dateTimeRangeButton"
                :column="column"
              ></date-time-range-button>
            </el-form-item>
          </template>
        </template>
        <el-button
          type="primary"
          @click="simpleSubmitForm"
          v-if="
            searchOptions &&
              searchOptions.simple &&
              searchOptions.simple.length > 1
          "
          >查询
        </el-button>
        <el-button
          class="button-gray"
          v-if="
            searchOptions &&
              searchOptions.simple &&
              searchOptions.simple.length > 1 &&
              !searchOptions.hiddenReset
          "
          @click="simpleClear"
          >重置
        </el-button>
        <el-button
          v-if="
            searchOptions &&
              searchOptions.complex &&
              searchOptions.complex.length > 0
          "
          @click="complexFunc"
          style="background: #f28f4e; color: #fff; border: none"
          >高级搜索
          <i class="el-icon-arrow-up" v-show="complexShow"></i>
          <i class="el-icon-arrow-down" v-show="!complexShow"></i>
        </el-button>
      </div>
      <transition name="el-zoom-in-top" :duration="100">
        <el-row v-show="complexShow" class="complex-box">
          <template
            v-for="(column, index) in searchOptions && searchOptions.complex"
          >
            <el-col
              :key="index"
              v-if="column.hidden == true ? false : true"
              :span="column.isAllline ? 24 : column.span || 6"
              :style="column.style"
            >
              <div v-if="column.type == 'title'" class="column-title">
                {{ column.label }}
              </div>
              <el-row v-else>
                <el-col :span="column.isAllline ? column.span || 6 : 24">
                  <el-form-item
                    :label="column.label"
                    :prop="column.prop"
                    :label-width="
                      searchOptions.labelWidth || column.labelWidth || '100px'
                    "
                  >
                    <!--输入框-->
                    <el-input
                      :style="{ width: column.inputWidth || '200px' }"
                      v-if="column.type === columnType.input || !column.type"
                      :type="column.inputType || 'text'"
                      v-model.trim="formModel[column.prop]"
                      :placeholder="column.placeholder"
                    ></el-input>
                    <!--下拉框-->
                    <el-select
                      v-else-if="column.type === columnType.select"
                      v-model="formModel[column.prop]"
                      :placeholder="column.placeholder || '请选择'"
                      @change="selectChange(column)"
                      :multiple="column.multiple || false"
                      collapse-tags
                      filterable
                      :disabled="column.disabled"
                    >
                      <el-option
                        v-for="item in column.data"
                        :key="idName(item, column)"
                        :label="labelName(item, column)"
                        :title="labelName(item, column)"
                        :value="idName(item, column)"
                      ></el-option>
                    </el-select>

                    <!--单选按钮-->
                    <el-radio-group
                      v-else-if="column.type === columnType.radio"
                      v-model="formModel[column.prop]"
                      @change="radioChange(column)"
                      :disabled="column.disabled"
                    >
                      <el-radio
                        v-for="item in column.data"
                        :key="item.label || item.name"
                        :label="item.label || item.name"
                        :value="item.label || item.name"
                      ></el-radio>
                    </el-radio-group>
                    <el-radio-group
                      v-else-if="column.type === 'radioOne'"
                      v-model="formModel[column.prop]"
                      @change="radioOneChange(column)"
                      :disabled="column.disabled"
                    >
                      <el-radio
                        v-for="(item, index) in column.data"
                        :key="index"
                        :label="item.id || item.value"
                      >
                        <span>{{ item.label || item.name }}</span>
                        <!--                        <el-input v-if="item.type === 'input'" @change="$forceUpdate()"></el-input>-->
                      </el-radio>
                    </el-radio-group>

                    <!--多选按钮-->
                    <el-checkbox-group
                      v-else-if="column.type === columnType.checkbox"
                      v-model="formModel[column.prop]"
                    >
                      <el-checkbox
                        v-for="item in column.data"
                        :key="item.value || item.id"
                        :label="item.label || item.name"
                        :title="item.label || item.name"
                        :value="item.value || item.id"
                      ></el-checkbox>
                    </el-checkbox-group>
                    <!---级联下拉框----->
                    <casader-select
                      :ref="column.prop"
                      v-else-if="column.type === columnType.casaderSelect"
                      :formModel="formModel"
                      @cascaderChange="cascaderChange"
                      :column="column"
                    ></casader-select>
                    <!--开关-->
                    <el-switch
                      v-else-if="column.type === columnType.switch"
                      v-model="formModel[column.prop]"
                      @change="valueChange(column)"
                    ></el-switch>
                    <!--级联选择器-->
                    <el-cascader
                      v-if="column.type === columnType.cascader"
                      v-model="formModel[column.prop]"
                      :options="column.data"
                      @change="valueChange(column)"
                      :props="{
                        expandTrigger: 'click',
                        checkStrictly: true,
                        emitPath: column.emitPath || false,
                        label: column.labelKey || 'label',
                        value: column.valueKey || 'id',
                        children: column.childrenKey || 'children'
                      }"
                    ></el-cascader>
                    <el-cascader
                      :options="column.data"
                      v-if="column.type === columnType.cascaderMultiple"
                      v-model="formModel[column.prop]"
                      :props="cascaderProp"
                      @change="valueChangeMultiple($event, column)"
                      size="mini"
                      collapse-tags
                    >
                      <!--                      <template slot-scope="{data }">-->
                      <!--                        <div v-if="column.data[0].label == data.label">-->
                      <!--                          <el-checkbox-->
                      <!--                            v-model="isCheckedAll"-->
                      <!--                            @change="checkAll($event, column)"-->
                      <!--                            class="all-select-style"-->
                      <!--                          >-->
                      <!--                            全选-->
                      <!--                          </el-checkbox>-->
                      <!--                          <span>{{ data.label }}</span>-->
                      <!--                        </div>-->
                      <!--                      </template>-->
                    </el-cascader>
                    <!--月份选择器-->
                    <el-date-picker
                      v-else-if="column.type === columnType.dateMonthPicker"
                      v-model="formModel[column.prop]"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      type="month"
                      @change="valueChange(column)"
                      placeholder="选择月"
                    >
                    </el-date-picker>
                    <!--日期选择器-->
                    <el-date-picker
                      v-else-if="column.type === columnType.datePicker"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      v-model="formModel[column.prop]"
                      type="date"
                      placeholder="选择日期"
                    ></el-date-picker>
                    <!--日期时间选择器-->
                    <el-date-picker
                      v-else-if="column.type === columnType.dateTimePicker"
                      type="datetime"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      v-model="formModel[column.prop]"
                      placeholder="选择日期时间"
                    ></el-date-picker>

                    <!--数字区间-->
                    <number-range
                      :ref="column.prop"
                      v-else-if="column.type === columnType.numberRange"
                      :column="column"
                    ></number-range>
                    <date-time-range
                      :ref="column.prop"
                      v-else-if="column.type === columnType.datetimeRange"
                      :column="column"
                    ></date-time-range>
                    <date-time-range-button
                      :ref="column.prop"
                      v-else-if="column.type === columnType.dateTimeRangeButton"
                      :column="column"
                    ></date-time-range-button>
                    <date-time-range-picker-options
                      :ref="column.prop"
                      v-else-if="
                        column.type === columnType.dateTimeRangePickerOptions
                      "
                      :column="column"
                    ></date-time-range-picker-options>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </template>
          <el-col :span="24" style="text-align: center">
            <el-button type="primary" @click="submitForm">查询 </el-button>
            <el-button class="button-gray" @click="complexClear"
              >重置
            </el-button>
          </el-col>
        </el-row>
      </transition>
    </el-form>
  </div>
</template>
<script>
import dateTimeRange from "../controls/dateTimeRange";
import dateTimeRangeButton from "../controls/dateTimeRangeButton";
import numberRange from "../controls/numberRange";
import casaderSelect from "../controls/cascaderSelect";
import fromTemplate from "@/mixin/fromTemplate.js";
import dateTimeRangePickerOptions from "../controls/dateTimeRangePickerOptions";
export default {
  mixins: [fromTemplate],
  components: {
    dateTimeRange,
    dateTimeRangeButton,
    numberRange,
    casaderSelect,
    dateTimeRangePickerOptions
  },
  props: {
    searchOptions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    toolConfig: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      isCheckedAll: true,
      cascaderProp: {
        checkStrictly: false,
        expandTrigger: "click",
        multiple: true,
        emitPath: true
      },
      moreShow: false,
      complexShow: false,
      currentSearchParams: {},
      formOptions: { formType: "search", columns: [] },
      newGoodsClassIdList: []
    };
  },
  mounted() {
    this.initData();
    this.searchSimpleInit();
    if (
      this.searchOptions &&
      (!this.searchOptions.simple || this.searchOptions.simple.length == 0) &&
      this.searchOptions.complex &&
      this.searchOptions.complex.length > 0
    ) {
      this.complexShow = true;
    }
  },
  computed: {
    idName() {
      return function(item = {}, column = {}) {
        if (column.hasOwnProperty("uniqueKey")) {
          return item[column.uniqueKey];
        }
        if (item.hasOwnProperty("value")) {
          return item.value;
        }
        return item.id;
      };
    },
    labelName() {
      return function(item = {}, column = {}) {
        if (column.hasOwnProperty("labelKey")) {
          return item[column.labelKey];
        }
        if (item.hasOwnProperty("label")) {
          return item.label;
        }
        return item.name;
      };
    }
  },
  methods: {
    // 非高级搜索 设置默认值
    searchSimpleInit() {
      if (!this.searchOptions.simple) return;
      this.searchOptions.simple.map(column => {
        //设置默认值
        if (column.defaultValue != undefined) {
          this.formModel[column.prop] = column.defaultValue;
        }
      });
    },
    // 单数据搜索
    searchValue(val) {
      this.currentSearchParams = this.getSimpleParams();
      this.$emit("searchSubmit", this.currentSearchParams);
    },
    initData() {
      this.formOptions.columns = [
        ...(this.searchOptions.complex || []),
        ...(this.searchOptions.simple || [])
      ];
      this.setOptionsData(this.formOptions);
    },
    // 及联选择器选择全部
    checkAll(val, column) {
      if (val) {
        this.cascaderProp.checkStrictly = false;
        this.cascaderProp.emitPath = true;
      } else {
        this.cascaderProp.checkStrictly = true;
        this.cascaderProp.emitPath = false;
      }
      // this.getSelectData(column)
      column.data = Object.assign([], column.data);
      this.formModel[column.prop] = [];
      this.$forceUpdate();
    },
    //点击 高级搜索显示
    complexFunc() {
      this.complexShow = !this.complexShow;
      if (this.complexShow) {
        this.searchOptions.complex.map(column => {
          this.$set(
            this.formModel,
            column.prop,
            column.type == "checkbox" ||
              (column.type == "select" && column.multiple == true)
              ? []
              : ""
          );
          //设置默认值
          if (column.defaultValue != undefined) {
            this.formModel[column.prop] = column.defaultValue;
          }
        });
        this.$emit("clearSelect"); //置空级联选项
      }
    },
    moreClick() {
      this.moreShow = !this.moreShow;
    },
    // 关闭高级搜索
    closeComplexShow() {
      this.complexShow = false;
      this.$emit("clearSelect"); //置空级联选项
    },
    // 点击查询
    simpleSubmitForm() {
      this.currentSearchParams = this.getSimpleParams();
      this.$emit("searchSubmit", this.currentSearchParams);
    },
    // 获取组件数据
    getSpecialAttributes(columns) {
      let rtn = true;
      columns.map(item => {
        switch (item.type) {
          case this.columnType.datetimeRange:
          case this.columnType.dateTimeRangeButton:
            rtn = this.$refs[item.prop][0].getFormData();
            if (rtn) {
              this.formModel[item.prop] = rtn;
              this.formModel["st" + item.prop] = rtn.split(",")[0];
              this.formModel["ed" + item.prop] = rtn.split(",")[1];
            }
            break;
          //级联
          case this.columnType.casaderSelect:
            let selectForm = this.$refs[item.prop][0].getFormData();
            for (let i = 0; i < item.casaderOptions.length; i++) {
              let option = item.casaderOptions[i];
              if (
                option.rule &&
                option.rule[0].required &&
                !selectForm[option.prop]
              ) {
                this.$message({
                  type: "error",
                  message: option.rule[0].message
                });
                rtn = false;
                break;
              }
            }
            if (rtn) {
              Object.assign(this.formModel, selectForm);
            }
            break;
          case this.columnType.numberRange:
            rtn = this.$refs[item.prop][0].getFormData();
            if (rtn) {
              this.formModel[item.prop] = rtn;
              this.formModel["min" + item.prop] = rtn.split(",")[0];
              this.formModel["max" + item.prop] = rtn.split(",")[1];
            } else {
              this.formModel["min" + item.prop] = null;
              this.formModel["max" + item.prop] = null;
            }
        }
      });
      return rtn;
    },
    getSimpleParams() {
      let submitVisible = this.getSpecialAttributes(this.searchOptions.simple);
      if (submitVisible === false) return;
      let searchParam = {};
      let param = this.$utils.deepClone(this.formModel);
      this.searchOptions.simple &&
        this.searchOptions.simple.map(column => {
          this.dealPrivateComData(param, searchParam, column);
        });
      return searchParam;
    },
    getComplexParams() {
      //获取组件数据
      let submitVisible = this.getSpecialAttributes(this.searchOptions.complex);
      if (submitVisible === false) return;
      let searchParam = {};
      let param = this.$utils.deepClone(this.formModel);
      this.searchOptions.complex &&
        this.searchOptions.complex.map(column => {
          this.dealPrivateComData(param, searchParam, column);
        });
      return searchParam;
    },
    // 高级查询 点击提交
    submitForm() {
      let simpleParam = this.getSimpleParams();
      let complexParam = this.getComplexParams();
      this.currentSearchParams = { ...simpleParam, ...complexParam };
      this.$emit("searchSubmit", this.currentSearchParams);
    },
    dealPrivateComData(param, searchParam, column) {
      if (
        param[column.prop] !== "" &&
        param[column.prop] !== undefined &&
        param[column.prop] !== null
      ) {
        if (column.isFuzzy)
          searchParam[column.prop] = "%" + param[column.prop] + "%";
        else if (
          column.type == this.columnType.datetimeRange ||
          column.type == this.columnType.dateTimeRangeButton
        ) {
          searchParam["st" + column.prop] = this.formModel["st" + column.prop];
          searchParam["ed" + column.prop] = this.formModel["ed" + column.prop];
        } else if (column.type == this.columnType.numberRange) {
          searchParam["min" + column.prop] = this.formModel[
            "min" + column.prop
          ];
          searchParam["max" + column.prop] = this.formModel[
            "max" + column.prop
          ];
        } else if (column.type === this.columnType.cascaderMultiple) {
          // 多选级联全选选择 传数组
          // else if(!this.cascaderProp.checkStrictly && column.type === this.columnType.cascaderMultiple){// 多选级联全选选择 传数组
          if (!this.cascaderProp.checkStrictly) {
            //父子关联
            if (this.newGoodsClassIdList.length > 0) {
              searchParam[column.prop] = this.newGoodsClassIdList;
            }
          } else {
            //父子不关联
            if (param[column.prop].length > 0) {
              searchParam[column.prop] = param[column.prop];
            }
          }
        } else {
          searchParam[column.prop] = param[column.prop];
        }
      }
    },
    // 按钮事件
    btnCommon(btnObj) {
      this.$emit("btnCommon", btnObj);
    },
    // 重置
    simpleClear() {
      this.searchOptions.simple.map(column => {
        // 本月 本周 搜索框重置
        if (column.type == this.columnType.dateTimeRangeButton) {
          this.$refs[column.prop][0].clearData();
        }
        this.$set(
          this.formModel,
          column.prop,
          column.type == "checkbox" ||
            (column.type == "select" && column.multiple == true)
            ? []
            : ""
        );
      });
      this.$emit("clear", this.formModel);
    },
    //清空特殊组件
    clearSpecialAttributes() {
      this.searchOptions.complex &&
        this.searchOptions.complex.map(item => {
          switch (item.type) {
            case this.columnType.datetimeRange:
            case this.columnType.dateTimeRangeButton:
            case this.columnType.numberRange:
            case this.columnType.casaderSelect:
              this.$refs[item.prop][0].clearData();
              break;
          }
        });
    },
    // 高级搜索重置
    complexClear() {
      this.searchOptions.complex.map(column => {
        this.$set(
          this.formModel,
          column.prop,
          column.type == "checkbox" ||
            column.type == "cascaderMultiple" ||
            (column.type == "select" && column.multiple == true)
            ? []
            : ""
        );
        // 级联多选刷新
        if (column.type == "cascaderMultiple") {
          this.getSelectData(column);
          this.newGoodsClassIdList = [];
          this.isCheckedAll = true;
          this.cascaderProp = {
            checkStrictly: false,
            expandTrigger: "click",
            multiple: true,
            emitPath: true
          };
        }
      });
      this.clearSpecialAttributes();
      this.$emit("clear");
    }
  }
};
</script>
<style>
.search-box .btn-box {
  text-align: center;
}

.search-box .complex-box {
  padding: 6px;
  background-color: #f2f2f2;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 14px;
}

.search-box .complex-box .el-form-item {
  min-height: 38px;
}

.search-box .more-config {
  display: inline;
}

.search-box .more-little {
  margin-bottom: 14px;
}

/*级联多选样式*/
.search-box .el-cascader__tags {
  z-index: 10;
}

.search-box .all-select-style {
  display: inline-block;
  position: absolute;
  top: -25px;
  left: 20px;
}

.search-box .el-cascader-menu__list {
  padding-top: 20px !important;
}

.search-box .button-green {
  background-color: #37c186;
  border-color: #37c186;
}

.search-box .button-red {
  background-color: #ed6650;
  border-color: #ed6650;
}

.search-box .button-orange {
  background-color: #f28f4e;
  border-color: #f28f4e;
}

.search-box .button-gray {
  /*background-color: #dcdcdc;*/
  border-color: #d8d8d8;
  color: #999;
}

.search-box .el-input--suffix .el-input__inner {
  padding-right: 0;
}

.search-box .search-input {
  width: 280px;
  line-height: normal;
}

.search-box .el-cascader {
  line-height: 30px;
}

/*单条搜索后面跟的搜索按钮*/
.search-box .el-input-group__append,
.search-box .el-input-group__prepend {
  background-color: #458cff;
  color: #fff;
  border-color: #458cff;
  font-weight: 700;
  /*padding:0 30px;*/
}

.search-box .form-item-wrapper {
  display: flex;
  margin-bottom: 14px;
}

.search-box .form-item-wrapper .el-form-item,
.search-box .el-form-item .el-form-item {
  min-height: auto;
}

.search-box .form-item-wrapper .el-form-item__content,
.search-box .el-form-item__label {
  line-height: 30px;
}
.search-box .form-item-wrapper.inline-flex,
.search-box .inline-flex {
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/components/template/searchFormTemplate.vue